const HTTPStatus =
{
    Ok: 200,
    Created: 201,
    NoContent: 204,
    BadRequest: 400,
    NotFound: 404,
    Error: 500
}

export default HTTPStatus;
